import './../globals.js'
// import axios from 'axios'
// import cst_survey_base_deck from './CstSurveyBaseDeck'

export default function CstCustomerDataDeck (survey, hotelData) {
  var finished = async function () {
  }

  var fieldMap = {
    customer: {
      title: {
        title: 'customerTitle',
        type: 'select',
        options: ['salutationOptionMr', 'salutationOptionMrs', 'salutationOptionFamily'],
        db_name: 'customer_title'
      },
      firstname: {
        title: 'customerFirstname',
        type: 'text',
        db_name: 'customer_firstname'
      },
      lastname: {
        title: 'customerLastname',
        type: 'text',
        db_name: 'customer_surname'
      },
      email: {
        title: 'customerEmail',
        type: 'email',
        db_name: 'customer_email'
      }
    },
    visit: {
      from: {
        title: 'visitFrom',
        type: 'date',
        db_name: 'customer_visit_from'
      },
      to: {
        title: 'visitTo',
        type: 'date',
        db_name: 'customer_visit_to'
      },
      room: {
        title: 'visitRoom',
        db_name: 'customer_visit_room'
      }
    }
  }

  var changeLocale = function (locale) {
  }

  var getRemainingCardCount = function () {
    return 0
  }

  var parseFieldData = function (field, creation_fields) {
    if (field.db_name in creation_fields) {
      field.display = 1
      field.required = parseInt(creation_fields[field.db_name].required)
    } else {
      field.display = 0
    }
    field.value = ''
    return field
  }

  var generateFields = function () {
    for (var k in fieldMap.customer) {
      let field = fieldMap.customer[k]
      parseFieldData(field, hotelData.hotel.creation_fields)
    }
    for (var i in fieldMap.visit) {
      let field = fieldMap.visit[i]
      parseFieldData(field, hotelData.hotel.creation_fields)
    }
    return fieldMap
  }

  var init = function () {
  }

  init()

  return {
    getRemainingCardCount: getRemainingCardCount,
    changeLocale: changeLocale,
    type: 'customer-visit-data',
    current_card_index: 0,
    cards: [
      { type: 'card-customer-data',
        id: 1,
        content: generateFields(),
        needsOverflow: true
      }
    ],
    getNextCard: function () {
      if (this.current_card_index + 1 > this.cards.length) {
        return false
      } else {
        return this.cards[this.current_card_index++]
      }
    },
    hasNextCard: function () {
      return !(this.current_card_index + 1 > this.cards.length)
    },
    finished: finished
  }
}



// WEBPACK FOOTER //
// ./src/components/CstCustomerDataDeck.js